import { useQuery } from '@tanstack/react-query'
import CattlesApiService from 'services/cattlesApiServices'

export const useGetAvailableCowTags = () => {
	const {
		data = { availableTagsRaw: [], availableTagsOption: [] },
		refetch,
		isError,
		isLoading,
	} = useQuery({
		queryKey: ['availableCowTags'],
		queryFn: async () => {
			const available_tags = await CattlesApiService.getAvailableCowTags()
			const filtered = available_tags.tags.filter(el => el !== null)
			const options = filtered.map(el => ({
				title: el.toString(),
				id: el,
			}))
			return {
				availableTagsRaw: available_tags,
				availableTagsOption: options,
			}
		},
		staleTime: 50000,
		retry: 2,
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
